export const POST_WIDTH = 800;
export const BORDER_RADIUS = 6;
